import React from 'react';
import PropTypes from 'prop-types';
import Loader from '@adsk/bim360-matrix-react-loader';
import {issueWrapperArrayType} from '../../constants/proptype-validation';
import IssueSummaryContainer from './IssueSummaryContainer';

const IssuesList = ({issues, changeLocationAction, loading}) => (
  <div className="IssuesList">
    {issues.map(issue => (
      <IssueSummaryContainer
        key={issue.attributes.id}
        issue={issue.attributes}
        changeLocationAction={changeLocationAction}
      />
    ))}
    {loading && (
      <div className="IssuesList__loading-indicator">
        <Loader />
      </div>
    )}
  </div>
);

IssuesList.displayName = 'IssuesList';

IssuesList.propTypes = {
  issues: issueWrapperArrayType.isRequired,
  loading: PropTypes.bool.isRequired,
  changeLocationAction: PropTypes.func.isRequired
};

export default IssuesList;
